import { render, staticRenderFns } from "./recordEdit.vue?vue&type=template&id=0431313b&scoped=true"
import script from "./recordEdit.vue?vue&type=script&lang=js"
export * from "./recordEdit.vue?vue&type=script&lang=js"
import style0 from "./recordEdit.vue?vue&type=style&index=0&id=0431313b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0431313b",
  null
  
)

export default component.exports